class ProductForm {
  constructor(el, sel) {
    this.atc = el;
    this.form = this.atc.closest("form");
    this.upsellItems = this.form.querySelectorAll("[data-upsell-item]");
  }

  init() {
    if (this.form) {
      this.atc.addEventListener("click", (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }

  async addToCart() {
    this.atc.disabled = true;

    // prepare body of the POST
    const formData = new FormData(this.form);
    const body = new URLSearchParams(formData);

    if (this.upsellItems.length > 0) {
      // get all the upsell item variant ids and add as hidden line item propery.
      const upsellIds = [];
      this.upsellItems.forEach((item) => {
        if (item.value && item.value != "") {
          const id = item.selectedOptions[0].getAttribute("data-upsell-id");
          if (id && id != "") upsellIds.push(id);
        }
      });

      if (upsellIds.length > 0)
        body.set("properties[_upsell_variant_ids]", upsellIds.join(","));
    }

    // add to cart
    try {
      const req = await fetch("/cart/add.js", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        body,
      });
      const res = await req.json();

      if (req.status === 200) {
        if (res?.properties?._upsell_variant_ids) {
          const ids = res.properties._upsell_variant_ids.split(",");
          const upsellReq = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: ids.map((id) => ({
                id,
                quantity: res.quantity,
                properties: {
                  _upsell_parent_variant_id: res.id,
                  "Option For": res.product_title,
                },
              })),
            }),
          });

          await upsellReq.json();
        }

        window.SLIDECART_UPDATE();
        window.SLIDECART_OPEN();
      }

      this.atc.disabled = false;
    } catch (e) {
      console.error(e);
      this.atc.disabled = false;
    }
  }
}

class Slider {
  constructor(el, sel) {
    this.el = el;
    this.options = JSON.parse(el.getAttribute(sel));
    this.options.mediaQuery = "min";
  }

  async init() {
    this.mainSlider = new Splide(this.el, this.options);

    if (this.el.parentNode.querySelector("[data-connected-slider]")) {
      this.initConnectedSlider();
    }

    if(this.options.pagination) {
      this.mainSlider.on('mounted', () => {
        this.el.querySelectorAll('.splide__pagination__page').forEach((page) => {
          page.parentElement.addEventListener('click', () => {
            page.click()
          })
        })
      })
    }

    this.mainSlider.mount();

    this.mainSlider.on('move', () => {
      this.updateArrowVisibility();
    });

    this.updateArrowVisibility = () => {
      const prevArrow = this.el.querySelector('.pdp_arrow_prev');
      const nextArrow = this.el.querySelector('.pdp_arrow_next');

      if (!prevArrow || !nextArrow) {
        console.warn('Splide arrows not found')
        return;
      }

      prevArrow.style.display = this.mainSlider.index === 0 ? 'none' : ''

      nextArrow.style.display = this.mainSlider.index === this.mainSlider.Components.Slides.getLength() - 1 ? 'none': '';
    }

    this.updateArrowVisibility();

    if(this.options.autoHeight) {
      const updateHeight = () => {
        const slide = this.mainSlider.Components.Slides.getAt(this.mainSlider.index).slide;
        slide.parentElement.style.height = slide.offsetHeight + 'px';
      };

      this.mainSlider.on('active resized', updateHeight);
      updateHeight();
    }

    if (this.options.adaptiveHeight) {
      this.mainSlider.on("move resize", (newIndex) =>
        this.updateHeight(this.mainSlider, newIndex),
      );
      this.updateHeight(this.mainSlider);
    }

    if (this.options.instantStyleChange) {
      this.mainSlider.on("move", (newIndex) =>
        this.instantStyleChange(this.mainSlider, newIndex),
      );
    }
  }

  updateHeight(slider, newIndex) {
    const slide = slider.Components.Slides.getAt(
      typeof newIndex == "number" ? newIndex : slider.index,
    ).slide;
    const elTarget = slide.firstElementChild;

    slide.parentElement.parentElement.style.height =
      elTarget.offsetHeight + "px";
  }

  initConnectedSlider() {
    const connectedEl = this.el.parentNode.querySelector(
      "[data-connected-slider]",
    );
    const connectedOptions = JSON.parse(
      connectedEl.getAttribute("data-connected-slider"),
    );

    const mainSliderHeight =
      this.mainSlider.root.getBoundingClientRect().height;

    if (mainSliderHeight < connectedOptions.sliderHeight) {
      connectedOptions.height = mainSliderHeight;
    } else {
      connectedOptions.height = connectedOptions.sliderHeight;
    }

    connectedOptions.height = connectedOptions.height + "px";

    const connectedSlider = new Splide(connectedEl, connectedOptions);

    this.mainSlider.on("move", (newIndex) => {
      connectedSlider.go(newIndex);

      if (connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(connectedSlider, newIndex);
      }
    });

    connectedSlider.on("move", (newIndex) => {
      this.mainSlider.go(newIndex);
      if (connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(connectedSlider, newIndex);
      }
    });

    if (connectedEl.hasAttribute("data-is-navigation")) {
      connectedSlider.on("click", (Slide) => {
        connectedSlider.go(Slide.index);
      });
    }

    connectedSlider.mount();
  }

  instantStyleChange(slider, newIndex) {
    slider.Components.Slides.forEach((s) => {
      const { slide, index } = s;
      slide.classList.toggle("is-active", index === newIndex);
    });
  }
}


function slidecarthqCustom() {
  function listenForInjection() {
    const targetNode = document.querySelector("body");

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "childList" &&
          mutation.target.id == "slidecarthq"
        ) {
          if (targetNode.querySelector("#slidecarthq")) {
            attachCustomActions();
            observer.disconnect();
          }
        }
      }
    });

    observer.observe(targetNode, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  }

  async function attachCustomActions() {
    const targetNode = document.querySelector("#slidecarthq");

    const observer = new MutationObserver(async (mutationList, observer) => {
      // check if a upsell item is in cart
      if (window.SLIDECART_STATE) {
        const cartItems = window.SLIDECART_STATE().cart.items;
        const itemsToRemove = [];

        for (const item of cartItems) {
          if (item.properties._upsell_parent_variant_id) {
            const parentId = item.properties._upsell_parent_variant_id;

            // check if parent of this upsell is in cart
            const parentItem = cartItems.find(
              (el) =>
                el.id == parentId &&
                el.properties?._upsell_variant_ids &&
                el.properties?._upsell_variant_ids.includes(item.id),
            );

            // if not in cart, add to the remove list
            if (!parentItem) itemsToRemove.push(item);
          }
        }

        if (itemsToRemove.length > 0) {
          for (const item of itemsToRemove) {
            try {
              const req = await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0,
                })
              });

              await req.json();

              if (req.status === 200) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }
            } catch (e) {
              console.error(e);
            }
          }
        }
      }
    });

    observer.observe(targetNode, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  listenForInjection();
}

/*
  YouTubePlayer use example:
  
  <div data-player="init">
    {% assign video_id = block.settings.embed  | split: '/' | last | split: '?' | first  %}
    <div
      data-player="trigger"
      data-id="{{ video_id }}"
    >
      <div id="player"></div>
    </div>
  </div>
*/
class YouTubePlayer {
  constructor(el, sel) {
    this.el = el;
    this.option = el.getAttribute('data-player');
    this.video_id = el.getAttribute('data-id');
  }

  init() {
    if (this.option == 'trigger') {
      this.el.addEventListener("click", (e) => {
        const playerContainer = this.el.querySelector("#player")
        const videoId = this.video_id
        let player;

        function onYouTubeIframeAPIReady() {
          player = new YT.Player(playerContainer, {
            height: '100%',
            width: '100%',
            videoId: videoId,
            playerVars: {
              'playsinline': 1
            },
            events: {
              'onReady': onPlayerReady,
            }
          });
        }

        function onPlayerReady(event) {
          event.target.playVideo();
        }

        onYouTubeIframeAPIReady();
      });
    }
  }
}

const handleGalleryNavigationArrows = (element) => {
  const prevBtn = element.querySelector("[data-gallery-scroll-button].scroll-left");
  const nextBtn = element.querySelector("[data-gallery-scroll-button].scroll-right");
  const isDesktop = matchMedia("(min-width: 1024px)").matches;
  const thumbScroller = element.querySelector("[data-gallery-scroller]");
  if (!prevBtn || !nextBtn || !isDesktop || !thumbScroller) return;

  const updateButtonVisibility = () => {
    setTimeout(() => {
      if (thumbScroller.scrollLeft > 4) {
        prevBtn.classList.add("visible");
      } else {
        prevBtn.classList.remove("visible");
      }

      if (thumbScroller.scrollLeft < thumbScroller.scrollWidth - thumbScroller.clientWidth) {
        nextBtn.classList.add("visible");
      } else {
        nextBtn.classList.remove("visible");
      }
    }, 500);
  }

  updateButtonVisibility();

  for (i = 0; i < 2; i ++) {
    const btn = i == 0 ? prevBtn : nextBtn;

    btn.addEventListener("click", updateButtonVisibility);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  // load custom atc button to work with add-ons
  const productAtcCustom = document.querySelector("[data-product-atc-custom]");
  if (productAtcCustom) {
    new ProductForm(productAtcCustom, "data-product-atc-custom").init();
  }

  // load custom slider (added for the video gallery on pdp but can be used for other things)
  const slider = document.querySelector("[data-slider]");
  if (slider) {
    new Slider(slider, "data-slider").init();
  }

  // load youtube player
  const ytPlayerInit = document.querySelector("[data-player='init']");
  if (ytPlayerInit) {
    // load youtube script dynamically when needed
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);

    const ytVideos = document.querySelectorAll("[data-player='trigger']");
    if (ytVideos && ytVideos.length) {
      ytVideos.forEach(video => {
        new YouTubePlayer(video, "data-player").init();
      });
    }
  }

  // load the default thumbnail slider arrows on mobile for desktop on pdp
  const galleryNavigation = document.querySelector("[data-gallery-navigation][data-scroll-desktop]");
  if (galleryNavigation) {
    handleGalleryNavigationArrows(galleryNavigation);
  }

  slidecarthqCustom();
});
